<template>
	<base-modal :show="!!error" title="An error occurred" @close="handleError">
		<p>{{ error }}</p>
	</base-modal>
	<div class="card mt-5 text-info" style="background-color: #263238">
		<div class="card-body">
			<h1 class="card-title border-bottom mb-5">League Info</h1>
			<form @submit.prevent="submitLeagueForm">
				<div class="row g-2">
					<div v-if="userData2.userType === 'League Manager'" class="mb-5">
						<button
							v-if="showAddLeagueBtn"
							type="button"
							class="btn btn-dark btn-lg"
							@click="hideAddBtn"
						>
							Don't see your league? Add it!
						</button>
					</div>
					<div
						v-if="getLeagues.length > 0"
						v-show="!addLeague"
						class="form-floating"
					>
						<select
							class="form-select"
							v-model.trim="userLeague"
							id="floatingSelectGridL"
						>
							<option
								v-for="league in getLeagues"
								:key="league.id"
								:value="{ leagueId: league.id, league: league }"
							>
								{{ league.league }}
							</option>
						</select>
						<label for="floatingSelectGridL">Leagues</label>
					</div>
					<div
					v-if="userData2.userType !== 'League Manager'"
						v-show="showDivisions"
						class="form-floating"
					>
						<select
						:disabled="userLeague.league.id === '0000000001'"
							class="form-select"
							v-model.trim="userDivision"
							id="floatingSelectGridL"
						>
							<option
								v-for="division in getDivisions"
								:key="division.id"
								:value="{ divisionId: division.id, division: division }"
							>
								{{ division.division }}
							</option>
						</select>
						<label for="floatingSelectGridL">Divisions</label>
					</div>
					<div class="mt-2">
						<button
							v-if="showSelectALeagueBtn"
							type="button"
							class="btn btn-dark btn-lg"
							@click="hideSelectBtn"
						>
							Find your league!
						</button>
					</div>
					<div v-show="addLeague" class="row g-2">
						<h4 class="mt-3">Add your league!</h4>
						<div class="form-floating">
							<input
								type="text"
								class="form-control"
								id="floatingNewLeague"
								v-model.trim="addNewLeague"
							/>
							<label for="floatingNewLeague">Your League Name</label>
						</div>
						<div class="form-floating">
							<input
								type="text"
								class="form-control"
								id="floatingLeagueCity"
								v-model.trim="addLeagueCity"
							/>
							<label for="floatingNewLeague">Location - City and State</label>
						</div>
					</div>
					<div
						v-if="
							userLeague.league ||
							(addNewLeague.length > 1 && addLeagueCity.length > 1)
						"
						class="mt-2"
					>
						<button :disabled="isLoading" class="btn btn-outline-info btn-lg">
							<div v-show="isLoading">
								<i class="fa-solid fa-baseball fa-spin"></i>
								Loading...
							</div>
							<div v-show="!isLoading">Next</div>
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	emits: ['league-step-complete', 'league-data', 'skip-step'],
	props: ['userData2'],
	data() {
		return {
			isLoading: false,
			userLeague: {
				leagueId: '',
				league: '',
			},
			userDivision: {
				divisionId: '',
				division: ''
			},
			addNewLeague: '',
			addLeagueCity: '',
			error: null,
			addLeague: false,
			showAddLeagueBtn: true,
			showSelectALeagueBtn: false,
			showDivisions: false
		};
	},
	created() {
		this.fetchLeagues();
	},
	computed: {
		getLeagues() {
			return this.$store.getters['leagues/allLeagues'];
		},
		getDivisions(){
			return this.$store.getters['leagues/allDivisions']
		},
		getTeams() {
			return this.$store.getters['teams/allTeams'];
		},
		getUserType() {
			return this.$store.getters.userType;
		}
	},
	watch: {
		userLeague() {
			this.fetchDivisions()
			// if(userLeague.league === 'No League') return
			this.showDivisions = true
		}
	},
	methods: {
		selectALeague() {
			this.userLeague = '';
			this.addLeague = true;
		},
		hideAddBtn() {
			this.showAddLeagueBtn = false;
			this.showSelectALeagueBtn = true;
			this.addLeague = true;
			this.userLeague = '';
		},
		hideSelectBtn() {
			this.showAddLeagueBtn = true;
			this.showSelectALeagueBtn = false;
			this.addLeague = false;
			this.addNewLeague = '';
			this.addLeagueCity = '';
		},
		async submitLeagueForm() {
			this.isLoading = true;
			// this.validateForm();
			// if (!this.formIsValid) {
			// 	return;
			// }
			if (this.userLeague === '') {
				const payloadNewLeague = {
					league: this.addNewLeague + ' - ' + this.addLeagueCity,
				};
				try {
					await this.$store.dispatch('leagues/addNewLeague', payloadNewLeague);
					this.$emit('league-step-complete');
					this.$emit('league-data', payloadNewLeague);
				} catch (err) {
					this.error = err.message || 'Set user info failed... Try again.';
				}
				this.isLoading = false;
			} else {
				const payload = {
					league: this.userLeague.league,
					leagueId: this.userLeague.leagueId,
					divisionId: this.userDivision.divisionId,
					division: this.userDivision.division
				};
				try {
					await this.$store.dispatch('setUserLeague', payload);
					this.$emit('league-step-complete');
					this.$emit('league-data', payload);
					this.fetchTeams();
				} catch (err) {
					this.error = err.message || 'Set user info failed... Try again.';
				}
			}
		},
		handleError() {
			this.error = null;
		},
		async fetchLeagues() {
			try {
				this.isLoading = true;
				await this.$store.dispatch('leagues/fetchLeagues');
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			this.isLoading = false;
		},
		async fetchDivisions() {
			const payload = {
				leagueId: this.userLeague.leagueId
			}
			try {
				await this.$store.dispatch('leagues/fetchSignUpDivisions', payload);
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
		},
		async fetchTeams() {
			try {
				this.isLoading = true;
				await this.$store.dispatch('teams/fetchTeams');
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			this.isLoading = false;
		},
	},
};
</script>

<style scoped>
select:disabled {
	background-color: rgb(12, 18, 24);
}
</style>
